import Vue from 'vue'
import env from '../services/environment'

let apiPath = 'https://' + env.apiTargetPath + env.apiPrefix

export default {
  checkEmail: function (email) {
    let apiDetailPath = '/users/find?email=' + email
    return Vue.http.get(apiPath + apiDetailPath)
  },
  pingCloud: function () {
    let apiDetailPath = '/users/me'
    return Vue.http.get(apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  getMyProfile: function () {
    let apiDetailPath = '/users/me'
    return Vue.http.get(apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js